import React from "react";

interface Props {
  note: server.dto.Note
}

const NoteFull = ({ note }: Props) => {
  return <>
    <div>{note.title}</div>
    <div className="s1_small" dangerouslySetInnerHTML={{
      __html: note.body
    }}></div>
  </>;
};

export default NoteFull;